import { render } from "./app-menu.vue?vue&type=template&id=790b38d4&scoped=true"
import script from "./app-menu.vue?vue&type=script&lang=js"
export * from "./app-menu.vue?vue&type=script&lang=js"

import "./app-menu.vue?vue&type=style&index=0&id=790b38d4&lang=less&scoped=true"

import exportComponent from "D:\\cwzl\\cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790b38d4"]])

export default __exports__